import { FunctionComponent } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { Icon } from "@/components";

import { classNames } from "@/utils/classNames";

interface ReachOutBulkActionItemProps {
	testId: string;
	icon: IconDefinition;
	/** The icon tile's colours. */
	iconClassName: string;
	title: string;
	description: string;
	/** Faded while another path of the menu is expanded. */
	dimmed: boolean;
	onClick: () => void;
}

/**
 * One bulk-only action under the reach-out paths ("Revert assigned campaign", "Confirm preassigned
 * campaigns"): a divider, then the item. It opens its owner's confirm dialog; the menu closes.
 */
export const ReachOutBulkActionItem: FunctionComponent<ReachOutBulkActionItemProps> = ({
	testId,
	icon,
	iconClassName,
	title,
	description,
	dimmed,
	onClick,
}) => (
	<>
		<div className="mx-2 my-1 h-px bg-border-light" />
		<div
			className={classNames(
				"group/item flex cursor-pointer gap-3 rounded-lg p-2.5 transition-opacity hover:bg-gray-100",
				dimmed ? "opacity-40" : ""
			)}
			data-testid={testId}
			onClick={onClick}
		>
			<div
				className={classNames(
					"flex h-8 w-8 shrink-0 items-center justify-center rounded-lg",
					iconClassName
				)}
			>
				<Icon className="h-4 w-4" icon={icon} />
			</div>
			<div className="min-w-0 flex-1">
				<div className="text-[13.5px] font-semibold text-brand-black">{title}</div>
				<div className="mt-0.5 text-[11.5px] leading-snug text-text-meta">{description}</div>
			</div>
		</div>
	</>
);
